import main from "./main/main.mp4";
import mainMobile from "./main/main_mobile.mp4";
import mainReversed from "./main/main_reversed.mp4";
import mainReversedMobile from "./main/main_mobile_reversed.mp4";

// !file-loader?name=static/[name]-[contenthash].[ext]! - here to prevent converting small images (<10kb) from base64 encoding

import mainPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./main/main-poster.avif";
import mainReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./main/main_reversed-poster.avif";
import mainMobilePoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./main/main_mobile-poster.avif";
import mainMobileReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./main/main_mobile_reversed-poster.avif";

import technology from "./technology/intro.mp4";
import technologyMobile from "./technology/intro_mobile.mp4";
import technologyReversed from "./technology/intro_reversed.mp4";
import technologyReversedMobile from "./technology/intro_mobile_reversed.mp4";

import technologyPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./technology/intro-poster.avif";
import technologyReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./technology/intro_reversed-poster.avif";
import technologyMobilePoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./technology/intro_mobile-poster.avif";
import technologyMobileReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./technology/intro_mobile_reversed-poster.avif";

import design from "./design/design.mp4";
import designMobile from "./design/design_mobile.mp4";
import designReversed from "./design/design_reversed.mp4";
import designReversedMobile from "./design/design_mobile_reversed.mp4";

import designPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./design/design-poster.avif";
import designReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./design/design_reversed-poster.avif";
import designMobilePoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./design/design_mobile-poster.avif";
import designMobileReversedPoster from "!file-loader?name=static/[name]-[contenthash].[ext]!./design/design_mobile_reversed-poster.avif";

import {
  LANDSCAPE_MOBILE_MQ,
  LAPTOP_SCREEN_MQ,
  MOBILE_SCREEN_MQ,
} from "../../constants/breakpoints";

export type VideoResource = {
  tag: "main" | "technology" | "design";
  isReversed?: boolean;
  src: string;
  type: string;
  media: string;
  poster: string;
};

export const videoResources: VideoResource[] = [
  {
    tag: "main",
    src: main,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: mainPoster,
  },
  {
    tag: "main",
    src: main,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: mainPoster,
  },
  {
    tag: "main",
    src: mainMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: mainMobilePoster,
  },
  {
    tag: "main",
    isReversed: true,
    src: mainReversed,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: mainReversedPoster,
  },
  {
    tag: "main",
    isReversed: true,
    src: mainReversed,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: mainReversedPoster,
  },
  {
    tag: "main",
    isReversed: true,
    src: mainReversedMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: mainMobileReversedPoster,
  },
  {
    tag: "technology",
    src: technology,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: technologyPoster,
  },
  {
    tag: "technology",
    src: technology,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: technologyPoster,
  },
  {
    tag: "technology",
    src: technologyMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: technologyMobilePoster,
  },
  {
    tag: "technology",
    isReversed: true,
    src: technologyReversed,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: technologyReversedPoster,
  },
  {
    tag: "technology",
    isReversed: true,
    src: technologyReversed,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: technologyReversedPoster,
  },
  {
    tag: "technology",
    isReversed: true,
    src: technologyReversedMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: technologyMobileReversedPoster,
  },
  {
    tag: "design",
    src: design,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: designPoster,
  },
  {
    tag: "design",
    src: design,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: designPoster,
  },
  {
    tag: "design",
    src: designMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: designMobilePoster,
  },
  {
    tag: "design",
    isReversed: true,
    src: designReversed,
    type: "video/mp4",
    media: LAPTOP_SCREEN_MQ,
    poster: designReversedPoster,
  },
  {
    tag: "design",
    isReversed: true,
    src: designReversed,
    type: "video/mp4",
    media: LANDSCAPE_MOBILE_MQ,
    poster: designReversedPoster,
  },
  {
    tag: "design",
    isReversed: true,
    src: designReversedMobile,
    type: "video/mp4",
    media: MOBILE_SCREEN_MQ,
    poster: designMobileReversedPoster,
  },
] as const;
